import { cached, PAGE_DATA_TTL_MS, strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";
import { mapDtoToHowToGetSection } from "@shared/content-types/mappers/how-to-get-section";

import { type HomePageType, mapDtoToHomePage } from "@/_pages/home/model";

import { HTGParams, searchParams } from "./params";

const fetchHomePage = async () => {
  const homepage = strapiClient.single("home-page");
  const howToGetSection = strapiClient.single("how-to-get-section");

  const [homeData, htgData] = await Promise.all([
    homepage.find({
      ...searchParams,
    }),
    howToGetSection.find({
      ...HTGParams,
    }),
  ]);

  const home = mapDtoToHomePage(homeData);

  const htg = mapDtoToHowToGetSection(htgData);

  const dataWithHTG = {
    ...home,
    htg,
  };

  return rebuild(dataWithHTG) as HomePageType;
};

/**
 * Данные страницы одинаковы для всех и меняются только правкой в CMS, а запрос
 * с глубоким populate занимает больше секунды и целиком ложится в TTFB.
 * Минута совпадает с s-maxage в Cache-Control страниц.
 */
export const getHomePage = () =>
  cached("home-page", PAGE_DATA_TTL_MS, fetchHomePage);
